import { createWeb3Modal, defaultConfig } from '@web3modal/ethers5/react'

const initWeb3Modal = () => {
  const projectId = '54f8cc197cdfda5bb77c591d4229c236'

  const chains = [
    {
      chainId: 1,
      name: 'Ethereum Mainnet',
      currency: 'ETH',
      explorerUrl: 'https://etherscan.io',
      rpcUrl: 'https://ethereum-rpc.publicnode.com',
    },
  ]

  // 3. Create your application's metadata object
  const metadata = {
    name: 'SpaceN',
    description: 'SpaceN',
    url: window.location.href,
    icons: ['https://coscription.ai/files/logo.png'],
  }

  // 4. Create Ethers config
  const ethersConfig = defaultConfig({
    /*Required*/
    metadata,

    /*Optional*/
    enableEIP6963: true, // true by default
    enableInjected: true, // true by default
    enableCoinbase: false, // true by default
  })

  // 5. Create a Web3Modal instance
  window.web3Modal = createWeb3Modal({
    ethersConfig,
    projectId,
    chains: chains,
    allowUnsupportedChain: false, // Allow users to switch to an unsupported chain.
    enableAnalytics: false, // Optional - defaults to your Cloud configuration
    enableOnramp: false, // Optional - false as default Enable users to buy crypto with fiat currency.

    themeVariables: {
      '--w3m-font-family': 'Montserrat',
      '--w3m-z-index': 1001,
      '--w3m-accent': '#2177f9',
    },
  })
}

export default initWeb3Modal
